import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig, createButtonConfig } from '@emazv72/ngx-imageviewer';

export const MY_IMAGEVIEWER_CONFIG: ImageViewerConfig = {
  /** component default width */
  width: 800,
  /** component default height */
  height: 600,
  /** component background style */
  bgStyle: '#ECEFF1',
  /** zoom scale step (using the zoom in/out buttons) */
  scaleStep: 0.1,
  /** touch rotate should rotate only 90 to 90 degrees */
  rotateStepper: false,
  /** loading message */
  loadingMessage: 'Cargando ...',

  buttonStyle: {
    /** font used to render the button icons */
    iconFontFamily: 'Material Icons',
    /** buttons transparence value */
    alpha: 1,
    /** buttons transparence value when mouse is over */
    hoverAlpha: 0.7,
    /** buttons background style */
    bgStyle: '#3880ff',
    /** buttons icon colors */
    iconStyle: '#ffffff',
    /** buttons border style */
    borderStyle: '#000000',
    /** buttons border width (0 == disabled) */
    borderWidth: 0,
  },
  tooltips: {
    /** enable or disable tooltips for buttons */
    enabled: true,
    /** tooltip background style */
    bgStyle: '#000000',
    /** tooltip background transparence */
    bgAlpha: 0.5,
    /** tooltips text style */
    textStyle: '#ffffff',
    /** tooltips text transparence */
    textAlpha: 0.9,
    /** tooltip padding */
    padding: 18,
    /** tooltip border radius */
    radius: 20,
  },
  // zoomOut button config
  zoomOutButton: {
    /** icon text */
    icon: 'remove',
    /** button tooltip */
    tooltip: 'Alejar',
    /** number used to determine the order of the buttons */
    sortId: 0,
    /** used to show/hide the button */
    show: true,
  },

  // shorter button configuration style
  nextPageButton: createButtonConfig('navigate_next', 'Página Siguiente', 0),
  beforePageButton: createButtonConfig('navigate_before', 'Página Anterior', 1),
  zoomInButton: createButtonConfig('add', 'Acercar', 1),
  rotateLeftButton: createButtonConfig('undo', 'Rotar Izquierda', 2),
  rotateRightButton: createButtonConfig('redo', 'Rotar Derecha', 3),
  resetButton: createButtonConfig('autorenew', 'Resetear Zoom', 4),
};

export interface IDialogPdfImageViewer {
  src: string;
  title?: string;
}

@Component({
  selector: 'app-pdf-image-viewer',
  templateUrl: './pdf-image-viewer.component.html',
  styleUrls: ['./pdf-image-viewer.component.scss'],
  providers: [
    {
      provide: IMAGEVIEWER_CONFIG,
      useValue: MY_IMAGEVIEWER_CONFIG,
    },
  ],
})
export class PdfImageViewerComponent implements OnInit {
  size = {
    width: window.innerWidth,
    height: window.innerHeight - 47,
  };

  constructor(
    public dialogRef: MatDialogRef<PdfImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogPdfImageViewer,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {}

  /**
   * Imprime documento que se está visualizando
   */
  download(): void {
    // window.print(); // no sirve para PDFs
    // TODO ver la forma de imprimir directamente (de acuerdo al tipo de archivo)

    if (this.data.src.match(/.(jpg|jpeg|png|gif)$/i)) {
      const imageWindow = window.open('', '_blank');
      imageWindow.document.write(
        '\
        <html>\
          <head>\
          </head>\
          <body>\
            <img src="' +
          this.data.src +
          '" >\
          </body>\
        </html>\
  ',
      );
      imageWindow.focus();
    } else {
      window.open(this.data.src, '_blank');
    }
  }

  /**
   * Cierra ventana emergente
   */
  close(): void {
    this.dialogRef.close({
      data: {
        mensaje: 'cerrado',
      },
    });
  }
}
